var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.href&&!_vm.target)?_c('router-link',{staticClass:"button",class:_vm.buttonClass,attrs:{"to":_vm.href}},[_vm._t("default")],2):_c('Button',{attrs:{"type":_vm.type,"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }